import type { ConnectionStatus } from "../core/connection";

type Props = {
  status: ConnectionStatus;
  eventCount: number;
};

const STATUS_LABEL: Record<ConnectionStatus, string> = {
  connecting: "Connecting…",
  connected: "Connected",
  timeout: "Not connected",
  error: "Init failed",
  destroyed: "Destroyed",
  mock: "Mock",
};

export function Header({ status, eventCount }: Props): React.JSX.Element {
  return (
    <header className="app-header">
      <picture className="app-logo">
        <source
          srcSet="/cdw-logo-white.png"
          media="(prefers-color-scheme: dark)"
        />
        <img src="/cdw-logo-black.png" alt="CDW" width={28} height={28} />
      </picture>
      <h1 className="app-title">Connect Agent Workspace Dev Kit</h1>
      <span className={`status-badge status-${status}`}>
        {STATUS_LABEL[status]}
      </span>
      <span className="event-count" title="Total events captured">
        {eventCount} events
      </span>
    </header>
  );
}
